import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import * as Yup from "yup";
import { Formik, FieldArray, Field } from "formik";
import config from "../../../../config";
import yupconfig from "../../../../yupconfig";
import moment from 'moment';
import { BookingNextAvailableModal, BookingResourceModal, BookingSelectedServicesData, BookingStaffAvailableTimeApi, NextStep, setBookingNextResourceItemTime, setBookingNextResourceItemTimef } from 'store/slices/bookingSlice';
import Select from "react-select";
import customToast from 'component/Toastr';

const NextAvailableBookingModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const isBookingNextAvailableModal = useSelector((state) => state.booking.isBookingNextAvailableModal);
    // const isBookingResourceItem = useSelector((state) => state.booking.isBookingResourceItem);
    const isBookingStepFourData = useSelector((state) => state.booking.isBookingStepFourData);
    // const availebleTimeObj = isBookingStepFourData && isBookingStepFourData.availebleTimeObj;
    const singleSelectedServiceData = isBookingStepFourData && isBookingStepFourData.singleSelectedServiceData;
    const start_datetime = isBookingStepFourData.start_datetime ? isBookingStepFourData.start_datetime : "";
    const resource_item_id = isBookingStepFourData.resource_item_id ? isBookingStepFourData.resource_item_id : "";
    const resource_name = isBookingStepFourData.resource_name ? isBookingStepFourData.resource_name : "";
    const isBookingStep = isBookingStepFourData && isBookingStepFourData.isBookingStep;


    const initialValues = {
        resource_item_id: "",
    };

    const validationSchema = Yup.object().shape({

    });
    yupconfig();

    const handleEmailVerifications = async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
        try {
            dispatch(BookingSelectedServicesData({ ...singleSelectedServiceData, datetime: start_datetime, resource_item_id: resource_item_id, resource_name: resource_name }))
            dispatch(NextStep(isBookingStep));
            dispatch(BookingNextAvailableModal(""));
        } catch (err) {
            setErrors(err.message);
            setStatus({ success: false });
            setLoading(false);
        }
    };


    return (
        <div>
            <div className={isBookingNextAvailableModal === "open" ? "modal fade show" : "modal fade"} id="add-emailverification" tabIndex="-1" aria-labelledby="addemailverificationModalLabel" style={{ display: isBookingNextAvailableModal === "open" ? "block" : "none" }}>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleEmailVerifications}>
                    {(formik) => {
                        // console.log(formik.values)
                        return (
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <form noValidate onSubmit={formik.handleSubmit}>
                                        <div className="modal-body pb-0">
                                            <div className="p-3">
                                            <a href="#" className="close mt-3 me-3" onClick={() => {
                                                dispatch(BookingNextAvailableModal(""));
                                            }}>
                                                <img src={config.imagepath + "close-icon.svg"} alt="" />
                                            </a>
                                                <h5 className="mb-3 fw-semibold text-dark">{t(`${isBookingStepFourData && isBookingStepFourData.title_text ? isBookingStepFourData.title_text : "The next available time for the service is :"}`)}</h5>
                                                <div>
                                                    <a className="btn bg-beige w-100 cursor-default color-wine mb-2">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                            <h6 className="font-bold text-dark mb-0">{isBookingStepFourData && isBookingStepFourData.display_text ? isBookingStepFourData.display_text : ""}</h6>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row mt-3 bg-cream p-4 justify-content-center">
                                                <div className="col-6">
                                                    <button className="preview btn me-1 cursor-pointer btn-preview w-100" style={{ fontSize:'15px' }} onClick={() => {
                                                        dispatch(BookingSelectedServicesData({ ...singleSelectedServiceData, staff_id: singleSelectedServiceData.staff_id, staffObjData: singleSelectedServiceData.staffObjData, totalprice: singleSelectedServiceData.totalprice, datetime: "", resource_item_id: "", resource_name: "" }));
                                                        dispatch(BookingNextAvailableModal(""));
                                                        dispatch(setBookingNextResourceItemTime([]));
                                                        dispatch(NextStep(isBookingStep));

                                                    }}>
                                                        {/* {t("Book another")} */}
                                                        {t("Choose A Different Option")}
                                                    </button>
                                                </div>
                                                <div className="col-6">
                                                    <button className="btn btn-primary w-100" type='submit'>
                                                        {t("Book this option")}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        )
                    }}
                </Formik>
            </div>
            {isBookingNextAvailableModal === "open" && <div className="modal-backdrop show"></div>}
        </div>
    )
}

export default NextAvailableBookingModal;